module.exports = __webpack_public_path__ + "static/media/ic_support_active.72b80fba.svg";